import { useState } from "react"
import styled from "styled-components"
import Faq from "../../models/Faq.model"
import Notice from "../../models/Notice.model"
import moment from "moment"
import { useNavigate } from "react-router-dom"

type Props = {
  notice: Notice
}


export default function NoticeItem(props: Props) {
  
  const navigate = useNavigate()

  return (
    <Container
      onClick={e => {
        navigate(`/notice/${props.notice.id}`)
      }}
    >
      <div className="area_q flex">
        <strong className="flex1">{props.notice.title}</strong>
        <span>{moment(props.notice.createdAt).format('YYYY.MM.DD')}</span>
      </div>
    </Container>
  )
}

const Container = styled.li`
  cursor: pointer;
  position: relative;

  .area{
    &_q{
      p.green{
        font-family: 'Montserrat';
        line-height: 26px;
      }
      strong{
        padding: 0 10px;
        line-height: 26px;
      }
      img{
        width: 12px;
        height: 26px;
        padding: 7px 0;
        transition: all .25s;
      }
    }

    &_a{
      color: #808080;
      line-height: 1.5;
    }
  }

  border-bottom: 1px #f2f2f2 solid;

  @media screen and (min-width: 501px) {
    padding: 26px 20px 21px;
    &:hover{
      .area_q strong{
        color: var(--main);
        transition: all .25s;
      }
    }

    .area{
      &_q{
        p, strong{
          font-size: 18px;
        }
      }
      &_a{
        padding: 21px 0 5px;
        font-size: 15px;
      }
    }


  }

  @media (max-width: 500px) {
    padding: 20px;

    .area{
      &_q{
        p, strong{
          font-size: 15px;
        }
        strong{
          font-family: 'Pretendard';
        }
      }
      &_a{
        padding-top: 20px;
        font-size: 13px;
      }
      
    }
  }
`